import { render } from "./WCAddToListButton.vue?vue&type=template&id=392f63c4&scoped=true"
import script from "./WCAddToListButton.vue?vue&type=script&lang=js"
export * from "./WCAddToListButton.vue?vue&type=script&lang=js"

import "./WCAddToListButton.vue?vue&type=style&index=0&id=392f63c4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392f63c4"]])

export default __exports__